/**
 * 店仓共享库存设置 - 单对象 - 主子表表单联动
 * 1. 主-库存共享设置==不包含：
 *  1.1. 不展示:子-表单part-共享比例、子-表单part-保底库存数
 *  1.2. 不展示:子表-共享比例、子表-保底库存数
 * 2. 注意 详情初始化/刷新 时 的处理
 */

export default {
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail }) => {
      this.subLinkChange(detail)
    }, false);

  },
  updated() {
    if (vm.$route.params.tableName == 'ST_C_INITIAL_SHARE') {
      this.initSubLinkChange()
    }
  },
  methods: {
    subLinkChange(_detail) {
      if (vm.$route.params.tableName == 'ST_C_INITIAL_SHARE' && !vm.$route.fullPath.includes("/SYSTEM/TABLE/")) {
        let detail = _detail
        if (!detail) { // 详情初始化/刷新
          const page = vm.$store.state[R3.getModuleName()]
          const childs = page.copyDataForReadOnly.addcolums[0].childs
          detail = {
            item: {colname: 'INITIAL_SHARE'},
            INITIAL_SHARE: Number(childs.find(i => i.colname == "INITIAL_SHARE").valuedata || '')
          }
        }
        if (detail.item && detail.item.colname == "INITIAL_SHARE") {
          console.log('参与库存共享-主子表联动::', detail);
          const page = vm.$store.state[R3.getModuleName()]
          const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
          const nowTabTable= _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.tableData.data)
          let newData = {
            tabIndex: page.tabCurrentIndex,
            inpubobj: nowTabForm
          }
          try {
            switch (detail.INITIAL_SHARE) {
              case 2: // 不包含
                nowTabForm.forEach((it, dex) => {
                  if (["RATIO", "QTY_MIN"].includes(it.colname)) {
                    it._show = false
                  }
                });
                newData = {
                  tabIndex: page.tabCurrentIndex,
                  inpubobj: nowTabForm
                }
                nowTabTable.tabth.forEach((it, dex) => {
                  if (["RATIO", "QTY_MIN"].includes(it.colname)) {
                    it.hide = true
                  }
                });
                break;
              default:
                nowTabForm.forEach((it, dex) => {
                  it._show = true
                });
                if (nowTabTable && nowTabTable.tabth) {
                  nowTabTable.tabth.forEach((it, dex) => {
                    it.hide = false
                  });
                }
                break;
            }
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData) // 更新子表-表单
            $store.commit(`${R3.getModuleName()}/updateTableListForRefTable`, nowTabTable) // 更新子表-表格
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    initSubLinkChange: _.debounce(function() {
      this.subLinkChange()
    }, 1200)
  }
}
